module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "场地平面图",
      "value": _vm.formData.changdi_pic.length + '/5'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.changdi_pic,
      "limit": 5,
      "name": 'changdi_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传场地平面照片")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "是否需要安装"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "active-color": "#ffad19",
            "active-value": 1,
            "inactive-value": 2,
            "size": "24"
          },
          model: {
            value: (_vm.formData.need_service),
            callback: function($$v) {
              _vm.$set(_vm.formData, "need_service", $$v)
            },
            expression: "formData.need_service"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rows": "2",
      "type": "textarea",
      "autosize": "",
      "label": "特殊情况说明",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入特殊情况说明"
    },
    model: {
      value: (_vm.formData.diynote),
      callback: function($$v) {
        _vm.$set(_vm.formData, "diynote", $$v)
      },
      expression: "formData.diynote"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '不能为空'
      }],
      "label": "收件人",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入收件人"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "手机号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "详细地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "是否需要发票"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "active-color": "#ffad19",
            "active-value": 1,
            "inactive-value": 2,
            "size": "24"
          },
          model: {
            value: (_vm.formData.need_fapiao),
            callback: function($$v) {
              _vm.$set(_vm.formData, "need_fapiao", $$v)
            },
            expression: "formData.need_fapiao"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.formData.need_fapiao == 1) ? _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '发票抬头不能为空'
      }],
      "label": "发票抬头",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入发票抬头"
    },
    model: {
      value: (_vm.formData.fapiao_taitou),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_taitou", $$v)
      },
      expression: "formData.fapiao_taitou"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.need_fapiao == 1) ? _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '税号不能为空'
      }],
      "label": "税号",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入税号"
    },
    model: {
      value: (_vm.formData.fapiao_shuihao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fapiao_shuihao", $$v)
      },
      expression: "formData.fapiao_shuihao"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.need_fapiao == 1) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("如果您所在的单位没有纳税人识别号请填写“无”")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79547e82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubJiansheStep3.vue
// module id = 2508
// module chunks = 0